import React from "react";
import AddIcon from "../../UIComponents/AddIcon";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import ShipManagementCard from "../ShipManagementCard";
import { getShipManagementList, getPaintCoating, getEquipmentMachinery, getStructureAndHull, getStores, getShipManagementDetail } from "../../Actions/ShipManagementAPI";
import MDocSdocCardView from "./MDocSdocCardView";
import API from "../../helpers/api";
import axios from "axios";

class MdSdupload extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            searchData: {
                pageNumber: 1,
                pageSize: 25,
                shipName: "",
                poNumber: "",
                documentName: ""
            },
            shiplistData: null
        }
        this.SearchData = this.SearchData.bind(this);
        this.ClearInput = this.ClearInput.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    getShipList = (item) => {
        let url = `${API.MDSDShiplist}`;
        axios.post(url, item)
            .then((response) => {
                this.setState({ shiplistData: response.data });
            })
            .catch((error) => {
                console.log(error);
            })
    }

    componentDidMount() {
        this.props.dispatch({ type: 'SubBannerTitle', data: "Md & SDoC Upload" });
        this.getShipList(this.state.searchData);
    }

    SearchData(Pgno) {
        const { dispatch } = this.props;
        this.state.searchData.pageNumber = Pgno;
        window.scrollTo(0, 0);
        this.getShipList(this.state.searchData);
        this.props.dispatch({ type: 'pagenumber', data: this.state.searchData });
    }

    eyeclick(item) {
        const { dispatch, history } = this.props;
        this.setState({ showSidePane: true })
        dispatch({ type: "ShowSidePan", data: true });
        history.push(`/Home/MdocSdocUpload/${item.shipId}`);
        window.scrollTo(0, 0);
    }
    ExceptionNav() {
        const { dispatch, history } = this.props;
        history.push(`/Home/MdocSdocUploadExceptions`);
        window.scrollTo(0, 0);
    }

    ShowSidePanel = () => {
        this.setState({ showSidePane: false })
        this.props.dispatch({ type: "ShowSidePan", data: false });
    }

    handleInputChange(e) {
        this.state.searchData.shipName = e.target.value;
        this.setState({});
        if (e.target.value === "") {
            this.getShipList(this.state.searchData);
        }
    }

    ClearInput() {
        this.state.searchData.shipName = "";
        this.getShipList(this.state.searchData);
        this.setState({});
    }

    hideSidePanel = () => {
        this.props.history.goBack();
        this.props.dispatch({ type: "ShowSidePan", data: false });
    }

    shipListdummy = {
        "items": [
            { "shipId": 1, "shipName": "SS Voyager 1", "totalDocuments": 20, "uploadedDocuments": 15 },
            { "shipId": 2, "shipName": "SS Voyager 2", "totalDocuments": 10, "uploadedDocuments": 5 },
            { "shipId": 3, "shipName": "SS Voyager 3", "totalDocuments": 30, "uploadedDocuments": 30 },
            { "shipId": 4, "shipName": "SS Voyager 4", "totalDocuments": 18, "uploadedDocuments": 16 },
            { "shipId": 5, "shipName": "SS Voyager 5", "totalDocuments": 12, "uploadedDocuments": 7 },
            { "shipId": 6, "shipName": "SS Voyager 6", "totalDocuments": 14, "uploadedDocuments": 10 },
            { "shipId": 7, "shipName": "SS Voyager 7", "totalDocuments": 25, "uploadedDocuments": 22 },
            { "shipId": 8, "shipName": "SS Voyager 8", "totalDocuments": 28, "uploadedDocuments": 28 },
            { "shipId": 9, "shipName": "SS Voyager 9", "totalDocuments": 21, "uploadedDocuments": 19 },
            { "shipId": 10, "shipName": "SS Voyager 10", "totalDocuments": 17, "uploadedDocuments": 17 },
            { "shipId": 11, "shipName": "SS Voyager 11", "totalDocuments": 24, "uploadedDocuments": 23 },
            { "shipId": 12, "shipName": "SS Voyager 12", "totalDocuments": 10, "uploadedDocuments": 6 },
            { "shipId": 13, "shipName": "SS Voyager 13", "totalDocuments": 20, "uploadedDocuments": 20 },
            { "shipId": 14, "shipName": "SS Voyager 14", "totalDocuments": 11, "uploadedDocuments": 9 },
            { "shipId": 15, "shipName": "SS Voyager 15", "totalDocuments": 19, "uploadedDocuments": 14 },
            { "shipId": 16, "shipName": "SS Voyager 16", "totalDocuments": 13, "uploadedDocuments": 12 },
            { "shipId": 17, "shipName": "SS Voyager 17", "totalDocuments": 22, "uploadedDocuments": 22 },
            { "shipId": 18, "shipName": "SS Voyager 18", "totalDocuments": 15, "uploadedDocuments": 13 },
            { "shipId": 19, "shipName": "SS Voyager 19", "totalDocuments": 16, "uploadedDocuments": 12 },
            { "shipId": 20, "shipName": "SS Voyager 20", "totalDocuments": 10, "uploadedDocuments": 8 },
            { "shipId": 21, "shipName": "SS Voyager 21", "totalDocuments": 18, "uploadedDocuments": 17 },
            { "shipId": 22, "shipName": "SS Voyager 22", "totalDocuments": 27, "uploadedDocuments": 26 },
            { "shipId": 23, "shipName": "SS Voyager 23", "totalDocuments": 23, "uploadedDocuments": 18 },
            { "shipId": 24, "shipName": "SS Voyager 24", "totalDocuments": 29, "uploadedDocuments": 29 },
            { "shipId": 25, "shipName": "SS Voyager 25", "totalDocuments": 30, "uploadedDocuments": 25 }
        ],
        "pageNumber": 1,
        "pageSize": 25,
        "totalCount": 76,
        "totalPages": 4,
        "hasPreviousPage": false,
        "hasNextPage": true
    }


    render() {
        const { ShipList } = this.props;
        return (
            <div className="full-height">
                {/* <button
                    className="btn btn-primary text-uppercase txtside-btn txtht-btn blue mt-3"
                    onClick={() => this.hideSidePanel()}
                >
                    &larr; Back
                </button> */}
                <div className="pt-3">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="panel-box">
                                        <div className="card MM-card-header mb-0" style={{ backgroundColor: "white" }}>
                                            <div className="card-body flex" style={{ padding: "0rem", backgroundColor: "#1E3A8A", color: "white" }}>
                                                <h5 className="card-title m-2" style={{ color: "092a51" }}>
                                                    MD & SDoC Upload
                                                </h5>
                                                {/* <div className="m-1 flex" onClick={this.NewitemNav}>
                                                    <span className="card-title m-auto">Add</span><AddIcon />
                                                </div> */}
                                            </div>
                                        </div>
                                        <div className="search-filter-box">
                                            <div className="row">
                                                <div className="col-lg-6">
                                                    <label className="form-label" >Ship Name</label><br></br>
                                                    <input className="form-control" type="text" name="shipname" value={this.state.searchData.shipName} placeholder="Ship Name" onChange={e => this.handleInputChange(e)}></input>
                                                </div>
                                                <div className="col-lg-6">
                                                    <label></label><br></br>
                                                    <div className="form-group mt-3 search-btn-col" style={{ textAlign: "end" }}>
                                                        <button
                                                            className="btn btn-danger text-uppercase txtside-btn txtht-btn ml-3"
                                                            type="button" onClick={() => this.ExceptionNav()}> {" "} Exceptions{" "}
                                                        </button>
                                                        <button
                                                            className="btn btn-primary text-uppercase txtside-btn txtht-btn blue ml-3"
                                                            type="submit" onClick={() => this.SearchData(1)}>Search
                                                        </button>
                                                        <button
                                                            className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                                                            type="button" onClick={() => this.ClearInput()}> {" "} Clear{" "}
                                                        </button>
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {this.state.shiplistData ?
                                <MDocSdocCardView
                                    arraylist={this.state.shiplistData.items}
                                    pageSize={this.state.shiplistData.pageSize}
                                    pageNumber={this.state.shiplistData.pageNumber}
                                    currentPage={this.state.shiplistData.currentPage}
                                    totalRecords={this.state.shiplistData.totalCount ? this.state.shiplistData.totalCount : 0}
                                    setUpdatedState={(value) => this.SearchData(value)}
                                    eyeclick={(item) => this.eyeclick(item)}
                                />
                                : ''}
                        </div>
                    </div>
                </div>
            </div >
        )
    }
    renderCard = () => [

    ]
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    }
}
function mapStateToProps(state) {
    return {
        showSidePane: state.SidePanReducer.sidePan || false,
        ShipList: state.MasterScreenReducer.ShipList
    }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MdSdupload));